module.exports = __webpack_public_path__ + "static/media/Bell_beaker_mba_england.0c2209ef.png";